import { Component, OnInit } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SessionService, StepsIdEnum, LookupsService, MessageTypeEnum } from '@app/base/core';
import { FormGroup } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { AlertService } from '@app/base/alerts/alert.service';

@Component({
  selector: 'app-acknowledge',
  templateUrl: './acknowledge.component.html',
  styleUrls: ['./acknowledge.component.css']
})
export class AcknowledgeComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  alertMsg: any = [];
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  messageTypeEnum: typeof MessageTypeEnum = MessageTypeEnum;
  message = '';
  emailAddress: string;

  // constructor
  constructor(public router: Router, public wizardSvc: MultistepsService,
    private alertService: AlertService, public sessionSvc: SessionService,
    public lookupSvc: LookupsService, public browser: PlatformLocation) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.ACKNOWLEDGE);
    this.wizardSvc.isWizardCompleted = true;
    this.wizardSvc.resetWizardState();

  }

  // used to initialise services
  ngOnInit() {
    this.browser.onPopState(() => {
      let url = window.location.href;
      url = url.replace('review', 'location');
      window.history.pushState(null, '', url);
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.ACKNOWLEDGE).form;
    this.message = this.lookupSvc.messages.find(x =>
      x.itemName.toUpperCase() === this.wizardSvc.serviceAddress.state.short_name.toUpperCase() &&
      x.messageType.toUpperCase() === this.messageTypeEnum.Acknowledge).message;
      // START - CXCO-1848 - Changes for Confirmation      
      if (this.wizardSvc.MainModel.kmiCommunication === 'Yes') {
        this.message = this.message.replace('YY', '');
      }
      else{
        this.message = this.message.replace('YY', 'Hidden');
      }
      // END - CXCO-1848 - Changes for Confirmation
    this.message = this.message.replace('XX', this.wizardSvc.MainModel.id.toString());    
    this.emailAddress = this.lookupSvc.messages.filter(x => x.itemName ===
       this.wizardSvc.serviceAddress.state.short_name && x.messageType === this.messageTypeEnum.Acknowledge)[0].emailAddress;

       const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
        if (subscribe && val) {
          subscribe.unsubscribe();
        }
        if (val) {
           this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Acknowledge Builder'));
          this.alertService.success(this.alertMsg.message);
        }
      });
  }
  next() { this.wizardSvc.nextStep(); }
  back() { this.wizardSvc.previousStep(); }

  // handling page refresh
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState:
    RouterStateSnapshot) { return this.wizardSvc.canDeactivateStep(route, state, nextState); }

  // used to navigate to home
  navigateHome() {
    this.sessionSvc.GetBcaData(null);
    this.router.navigate([
      this.sessionSvc.paramLdc.toLowerCase(),
      'builder',
      'home'
      ]);
  }
}
